import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import ErrorLayout from '../layouts/ErrorLayout';
import Starter from 'components/pages/Starter';
import Error404 from 'components/errors/Error404';
import PaymentPages from 'components/pages/PaymentPages';
import RecipientPage from 'components/pages/RecipientPage';
import ContactTypePage from 'components/pages/ContactTypePage';
import MyselfContactPage from 'components/pages/MyselfContactPage';
import ElseContactPage from 'components/pages/ElseContactPage';
import BusinessOrCharityContactPage from 'components/pages/BusinessOrCharityContactPage';
import ReviewPage from 'components/pages/ReviewPage';
import { routePaths } from './routePaths';
import PayPage from 'components/pages/PayPage';

const MainRoutes = () => {
  return (
    <Routes>
      <Route element={<ErrorLayout />}>
        <Route path="errors/404" element={<Error404 />} />
      </Route>
      <Route element={<MainLayout />}>
        <Route path={routePaths.HOME} element={<PaymentPages />} />
        <Route path={routePaths.CONTACT_EXISTING} element={<RecipientPage />} />
        <Route path={routePaths.CONTACT_TYPES} element={<ContactTypePage />} />
        <Route
          path={routePaths.CONTACT_MYSELF}
          element={<MyselfContactPage />}
        />
        <Route
          path={routePaths.CONTACT_SOMEONE_ELSE}
          element={<ElseContactPage />}
        />
        <Route
          path={routePaths.CONTACT_BUSINESS_CHARITY}
          element={<BusinessOrCharityContactPage />}
        />
        <Route path={routePaths.REVIEW_URL} element={<ReviewPage />} />
        <Route path={routePaths.PAY_URL} element={<PayPage />} />
        <Route path="pages/starter" element={<Starter />} />
      </Route>
      <Route path="*" element={<Navigate to="/errors/404" replace />} />
    </Routes>
  );
};

export default MainRoutes;
